module.exports = {"152525100":"乌里雅斯太镇","152525101":"道特淖尔镇","152525102":"嘎达布其镇","152525103":"满都胡宝拉格镇","152525104":"额吉淖尔镇","152525200":"呼热图淖尔苏木","152525201":"萨麦苏木","152525202":"嘎海乐苏木","152525203":"阿拉坦合力苏木","152525400":"乌里雅斯太工业区","152525503":"宝格达乌拉总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152525.json
// module id = 488
// module chunks = 0